<template>
    <a 
    class="duration-500 hover:scale-105 active:scale-100"
    :class="[
        $attrs.class, 'flex flex-col justify-around items-center text-[#59E3FF] text-2xl text-center py-2 px-4 w-60 h-60 rounded-2xl shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] border border-[#c1c1c1] cursor-pointer bg-white hover:bg-[#eafaff]'
        ]"
    v-bind="$attrs" >
        {{ title }}
        <slot></slot>
        <component :is="icon" v-if="icon" class="w-16 h-16" />
    </a>
</template>

<script>

export default {
    props: {
        title: String,
        icon: String,
    }
}
</script>
